var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogIcon = function SvgBlogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.667 3.167A.667.667 0 0 0 2 3.834v10.69l2.608-1.896a.66.66 0 0 1 .434-.127h8.291a.667.667 0 0 0 .667-.667V8.908a.667.667 0 0 1 1.333 0v2.926a2 2 0 0 1-2 2H5.217l-2.433 1.769c-.881.64-2.117.011-2.117-1.079V3.834a2 2 0 0 1 2-2h6a.667.667 0 1 1 0 1.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.09 2.565a1.333 1.333 0 0 0-1.862-.022l-3.365 3.21c-.17.164-.295.37-.36.597L8.028 8c-.298 1.038.698 1.982 1.719 1.627l1.796-.624c.194-.067.37-.178.513-.324l3.113-3.165c.513-.522.51-1.36-.008-1.878zm-.942.943 1.071 1.071-3.113 3.165-1.796.624.474-1.65z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.668 6.334c0-.368.298-.665.665-.665h2a.665.665 0 1 1 0 1.33h-2a.665.665 0 0 1-.665-.665M4.333 8.669a.665.665 0 1 0 0 1.33h2a.665.665 0 1 0 0-1.33z"
  })));
};
export default SvgBlogIcon;